export default "__VITE_ASSET__N5VqoYeq__"